import { render, staticRenderFns } from "./ProductModal.vue?vue&type=template&id=081d6dad"
import script from "./ProductModal.vue?vue&type=script&lang=ts"
export * from "./ProductModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('081d6dad')) {
      api.createRecord('081d6dad', component.options)
    } else {
      api.reload('081d6dad', component.options)
    }
    module.hot.accept("./ProductModal.vue?vue&type=template&id=081d6dad", function () {
      api.rerender('081d6dad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/ProductModal.vue"
export default component.exports